// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  Category2,
  Book,
  LanguageSquare,
  ShoppingBag,
  Receipt1,
  BackwardItem,
  CloudAdd,
  ProfileCircle,
  AttachSquare,
  Refresh,
  Setting2,
} from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  widgets: Category2,
  plan: Book,
  translation: LanguageSquare,
  product: ShoppingBag,
  email_template: Receipt1,
  product_type: BackwardItem,
  redbird: CloudAdd,
  users: ProfileCircle,
  module: AttachSquare,
  loading: Refresh,
  server_tools: Setting2,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const master: NavItemType = {
  id: "group-master",
  title: <FormattedMessage id="page.menu_items_master_label" />,
  icon: icons.widgets,
  type: "group",
  children: [
    {
      id: "group-master",
      title: <FormattedMessage id="page.menu_items_master_label" />,
      type: "collapse",
      icon: icons.widgets,
      children: [
        {
          id: "product-type",
          title: (
            <FormattedMessage id="page.menu_items_master_product_type_label" />
          ),
          type: "item",
          url: "/product-type/list",
        },
        {
          id: "product",
          title: (
            <FormattedMessage id="page.menu_items_master_products_label" />
          ),
          type: "item",
          url: "/product/list",
        },
        {
          id: "plan",
          title: <FormattedMessage id="page.menu_items_master_plan_label" />,
          type: "item",
          url: "/plan/list",
        },
        {
          id: "module",
          title: <FormattedMessage id="page.menu_items_master_module_label" />,
          type: "item",
          url: "/module/list",
        },
        {
          id: "translation",
          title: (
            <FormattedMessage id="page.menu_items_master_translation_label" />
          ),
          type: "item",
          url: "/translation/list",
        },
        {
          id: "email-template",
          title: (
            <FormattedMessage id="page.menu_items_master_email_template_label" />
          ),
          type: "item",
          url: "/email-template/list",
        },
        {
          id: "redbird",
          title: <FormattedMessage id="page.menu_items_master_redbird_label" />,
          type: "item",
          url: "/redbird/list",
        },
        {
          id: "server-tools",
          title: (
            <FormattedMessage id="page.menu_items_server_tools_label" />
          ),
          type: "item",
          url: "/server-tools",
        },
      ],
    },
  ],
};

export default master;
